<template>
  <v-layout>
    <v-flex xs12>
      <Login />
    </v-flex>
  </v-layout>
</template>

<script>
import Login from "@/components/Login";

export default {
  components: {
    Login,
  },
};
</script>
